/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class GroupPicker extends Component {
  @tracked
  inProgress = false;
  onPicked() {}

  @action
  pickGroup(group) {
    this.inProgress = true;

    // Wrap in a resolving promise to promisify non-promise return values.
    Promise.resolve()
      .then(() => {
        return this.onPicked(this.person, group);
      })
      .finally(() => {
        this.inProgress = false;
      });
  }
}
